var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.458 34.0625C36.458 34.278 36.3724 34.4847 36.22 34.637C36.0677 34.7894 35.861 34.875 35.6455 34.875H16.1455C15.93 34.875 15.7234 34.7894 15.571 34.637C15.4186 34.4847 15.333 34.278 15.333 34.0625V17.8125C15.333 17.597 15.4186 17.3903 15.571 17.238C15.7234 17.0856 15.93 17 16.1455 17C16.361 17 16.5677 17.0856 16.72 17.238C16.8724 17.3903 16.958 17.597 16.958 17.8125V27.397L22.1103 22.8906C22.2505 22.7679 22.4286 22.6971 22.6148 22.6901C22.801 22.683 22.984 22.7402 23.133 22.852L29.1059 27.332L35.1103 22.0781C35.189 22.0002 35.2828 21.9392 35.386 21.8988C35.4892 21.8585 35.5995 21.8397 35.7102 21.8436C35.8209 21.8474 35.9297 21.8739 36.0298 21.9213C36.1299 21.9687 36.2192 22.0361 36.2923 22.1194C36.3654 22.2026 36.4207 22.2999 36.4549 22.4053C36.489 22.5107 36.5012 22.6219 36.4908 22.7322C36.4803 22.8425 36.4474 22.9495 36.3941 23.0466C36.3408 23.1437 36.2682 23.2289 36.1807 23.2969L29.6807 28.9844C29.5405 29.1071 29.3624 29.1779 29.1762 29.1849C28.99 29.192 28.8071 29.1348 28.658 29.023L22.6851 24.5451L16.958 29.5562V33.25H35.6455C35.861 33.25 36.0677 33.3356 36.22 33.488C36.3724 33.6403 36.458 33.847 36.458 34.0625Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.9df589cb4b9fba755cdc3f60c164fc3e.svg";
export { ForwardRef as ReactComponent };